import React from 'react';
import PropTypes from 'prop-types';
import FilterList from './filterList';
import {
  //calculateFilterProps,
  createColumnFilterProps
} from './lib/filter';

import {
  isUndefined,
} from './lib/util';
import {
  filterAction,
  //filterActions,
  //filtersReset,
} from './lib/filter';


class TransactionColumnFilter extends React.Component {
/**
 * constructor
 * @param {Object} props
 */
constructor(props) {
    super(props);

    this.currentFilters = this.props.initialFilters || {};
    this.filtervalueList = [{name: 'Claim', nameFR: 'Demande de prestations', key: 'claim_01'}, 
                            {name: 'Claim Reversals', nameFR: 'Annulation d’une demande de prestations', key: 'reversal_02'}, 
                            {name: 'Predetermination', nameFR: 'Plan de traitement', key: 'predetermination_03'}, 
                            {name: 'Request for Outstanding Transaction', nameFR: 'Demande relative aux transactions en suspens', key: 'outstanding_04'}, 
                            {name: 'Summary Reconciliation', nameFR: 'Rapprochement sommaire', key: 'summary_reconcilation_05'}, 
                            {name: 'Payment Reconciliation', nameFR: 'Demande de rapprochement des paiements', key: 'payment_reconciliation_06'}, 
                            {name: 'Coordination of Benefit (COB) Transaction', nameFR: 'Transactions pour la coordination des prestations', key: 'cob_07'}, 
                            {name: 'Eligibility', nameFR: 'Vérification d’admissibilité', key: 'eligibility_08'}, 
                            {name: 'Attachment', nameFR: 'Pièce jointe', key: 'attachment_09'}];

  } 

  _filterRows = (value=undefined, key=undefined, addFilter=true, valueFunc=undefined, filteritemFunc=undefined) => {
    const filteredData = this.props.ncplFlattenData;
    if (!isUndefined(value) && !isUndefined(key)) {
      this._updateCurrentFilters(value, addFilter, key);
      const result = filterAction(filteredData, this._getCurrentFilters()[key], addFilter, valueFunc, filteritemFunc);
      if (!isUndefined(result)) {
        const filteredArray = result.filteredArray;
        const dataWithFilter = result.dataWithFilter;

        this.props.setNcplTableData(dataWithFilter);
        
        this.props.onFilterUpdate && this.props.onFilterUpdate(filteredArray, this._getCurrentFilters());
      }
    }
  }

  _getNonFilteredValues = () => {
    if (isUndefined(this._getCurrentFilters()) || isUndefined(this._getCurrentFilters()['key']))
    {
      return this.filtervalueList;
    }
    return this.filtervalueList.filter((itm) => {
      return this._getCurrentFilters()['key'].filter((f) => itm.key === f).length === 0; 
    });
  }

  _getCurrentFilters = () => {
    return this.currentFilters;
  }
  
  _updateCurrentFilter = (filter, add=true, key=undefined) => {
    if (!isUndefined(key, true) && !isUndefined(filter, true)) {
      if (isUndefined(this.currentFilters[key])) {
        this.currentFilters[key] = [];
      }

      if (add) {
        if (this.currentFilters[key].indexOf(filter) < 0) {
          this.currentFilters[key].push(filter);
        }
      } else {
        if (this.currentFilters[key].indexOf(filter) >= 0) {
          const index = this.currentFilters[key].indexOf(filter);
          this.currentFilters[key] = [...this.currentFilters[key].slice(0, index), ...this.currentFilters[key].slice(index + 1)];
        }
      }
    }
  }

  _updateCurrentFilters = (filters=[], add=true, key) => {
    if (!isUndefined(filters) && !isUndefined(key)) {
      filters.forEach((filterItem) => {
        this._updateCurrentFilter(filterItem, add, key);
      });
    }
  }

  _resetRows = (filterValues=[], key=undefined, selectAll=true, valueFunc=undefined, filteritemFunc=undefined) => {
    this._updateCurrentFilters(filterValues, selectAll, key);
    if (!selectAll)
    {
      filterValues = [];
    }

    this._filterRows(filterValues, key, false, valueFunc, filteritemFunc);
  }


  render() {

    
    const filterProps = createColumnFilterProps({
        currentfilters: this._getCurrentFilters(),
        filtervalueList: this.filtervalueList, 
        filtervalueProperty: 'key', // filterkey,
        itemDisplayValueFunc: (itm, key) => { return this.props.language === 'en'? itm.name : itm.nameFR}, // itemDisplayValueFunc,
        filterItemFunc: (itm, key) => { return itm[key] ? true : false },
        itemSortValueFunc: undefined, // itemSortValueFunc,
        sortKey: 'name', // sortKey,
        sortType: undefined, // sortType,
      });

    return <FilterList 
    {...filterProps}
    filterRows={this._filterRows}
    filterMultipleRows={this._filterMulipleRows}
    resetRows={this._resetRows}
    sortRows={this._sortRows}
    language={this.props.language}/>;
  }
}

TransactionColumnFilter.propTypes = {
    setNcplTableData: PropTypes.func.isRequired,
    ncplFlattenData:PropTypes.array.isRequired,
    language:PropTypes.string.isRequired,
  };
  
  export default TransactionColumnFilter;
  